import { DislikedMealRequest } from "@/clients/models/DislikedMealRequest";
import { MealsService } from "@/clients/services/MealsService";
import { QueryKeys } from "@/constants/query-keys";
import { guardGetUserFromLocalStorage } from "@/utils/request";
import { useMutation, useQueryClient } from "@tanstack/react-query";

export const useAddDislikedMeal = () => {
  const queryClient = useQueryClient();

  const mutation = useMutation({
    mutationKey: [QueryKeys.DISLIKED_MEALS],
    mutationFn: async (requestBody: DislikedMealRequest) => {
      const user = guardGetUserFromLocalStorage();
      return MealsService.addDislikedMealApiV1MealsDislikedPost(user.id, requestBody);
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [QueryKeys.DISLIKED_MEALS] });
    },
  });

  return {
    addDislikedMeal: mutation.mutate,
    addDislikedMealAsync: mutation.mutateAsync,
    isAddingDislikedMeal: mutation.isPending,
    isError: mutation.isError,
    error: mutation.error,
    response: mutation.data,
  };
};
